import { CatsRecordTypeEnum } from '@shared-enums/cats.enum';

import { CatsRecord } from './catsRecord';
import { Employee } from './employee';
import { IPerDiemConfigItem } from './PayrollTimesheet';
import { ITimesheetDate } from './timesheetHandler';

export class PerDiemCatsRecord extends CatsRecord {
  rowSpanOverride?: number; //this exists for the benefit of the table, it's not actually part of the record
  PerDiems?: IPerDiemConfigItem; //this exists for the benefit of the table, it's not actually part of the record

  constructor() {
    super('epd');
  }

  public getRequiredObject(employee: Employee, extDocument: string, date?: ITimesheetDate): this {
    if (date) this.Workdate = date.unix;
    else this.Workdate = employee.focusedDay?.unix ?? null;
    this.Extdocumentno = extDocument;
    this.Employeenumber = employee.EmpId;
    this.Quantity = '1';
    this.ZempCreatedBy = employee.datahub.user.getEmpId();
    this.RecCctr = employee.CostCenter;
    this.Statkeyfig = '';
    this.Zperdiemamount = ''; //default to empty string so we can see a UI placeholder. Converting to a number before saving will result in zero if unchanged anyway
    this.Zrecordtype = CatsRecordTypeEnum.EmployeePerDiem;
    return this;
  }
}
